import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { VisitData, RegistrationData, CheckoutCompletionData } from "../model/AnalyticModel";

export class AnalyticsGateway {
  static async GetSiteVisits(): Promise<VisitData | null> {
    try {
      const visitsDoc = doc(db, "website", "visits");
      const snapshot = await getDoc(visitsDoc);
      
      if (snapshot.exists()) {
        return snapshot.data() as VisitData;
      }
      return null;
    } catch (error) {
      console.error("Error fetching visits data:", error);
      return null;
    }
  } 

  static async GetRegistrations(): Promise<RegistrationData | null> {
    try {
      const registrationsDoc = doc(db, "website", "registrations");
      const snapshot = await getDoc(registrationsDoc);
      
      if (snapshot.exists()) {
        return snapshot.data() as RegistrationData;
      }
      return null;
    } catch (error) {
      console.error("Error fetching registrations data:", error);
      return null;
    }
  }  

  static async GetCheckoutCompletion(effectiveDate: Date): Promise<CheckoutCompletionData> {
    try {
      // Calculate date ranges
      const currentMonthStart = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth(), 1);
      const previousMonthStart = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth() - 1, 1);
      const previousMonthEnd = new Date(effectiveDate.getFullYear(), effectiveDate.getMonth(), 0, 23, 59, 59);
      
      // Get all orders from the last 60 days (to cover current and previous month)
      const sixtyDaysAgo = new Date(effectiveDate);
      sixtyDaysAgo.setDate(effectiveDate.getDate() - 60);
      
      const ordersRef = collection(db, "orders");
      const ordersQuery = query(
        ordersRef,
        where("createdAt", ">=", sixtyDaysAgo.toISOString())
      );
      const ordersSnapshot = await getDocs(ordersQuery);
      
      // Count orders by status and month
      let currentMonthCompleted = 0;
      let currentMonthIncomplete = 0;
      let previousMonthCompleted = 0;
      let previousMonthIncomplete = 0;
      
      ordersSnapshot.forEach((doc) => {
        const order = doc.data();
        const orderDate = new Date(order.createdAt);
        const isCompleted = order.status !== "PaymentPending";
        
        if (orderDate >= currentMonthStart) {
          if (isCompleted) {
            currentMonthCompleted++;
          } else {
            currentMonthIncomplete++;
          }
        } else if (orderDate >= previousMonthStart && orderDate <= previousMonthEnd) {
          if (isCompleted) {
            previousMonthCompleted++;
          } else {
            previousMonthIncomplete++;
          }
        }
      });
      
      return {
        completed: currentMonthCompleted,
        incomplete: currentMonthIncomplete,
        previousCompleted: previousMonthCompleted,
        previousIncomplete: previousMonthIncomplete
      };
    } catch (error) {
      console.error("Error fetching checkout completion data:", error);
      return {
        completed: 0,
        incomplete: 0,
        previousCompleted: 0,
        previousIncomplete: 0
      };
    }
  }
}